import { render, staticRenderFns } from "./appForgotPassword.vue?vue&type=template&id=8e775936&scoped=true&"
import script from "./appForgotPassword.vue?vue&type=script&lang=js&"
export * from "./appForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e775936",
  null
  
)

export default component.exports